export const LOGIN_WALL_ENABLED = (import.meta.env.VITE_LOGIN_WALL_ENABLED ?? "false").toLowerCase() === "true";
export const DATA_BASE_URL = (import.meta.env.VITE_DATA_BASE_URL ?? "/data").replace(/\/$/, "");
